// Client brand names are kept as-is across languages (brand names).
const clientLogos = [
  { name: 'Rozel', logoSrc: '/images/clients/Rozel.png' },
  { name: 'Addar', logoSrc: '/images/clients/Addar_Logo.png' },
  { name: 'Belive', logoSrc: '/images/clients/Belive_Logo.png' },
  { name: 'EasyParcel', logoSrc: '/images/clients/EasyParcel_Logo.png' },
  { name: 'Exabytes', logoSrc: '/images/clients/Exabytes_Logo.png' },
  { name: 'Mishu', logoSrc: '/images/clients/Mishu Sdn Bhd.png' },
  { name: 'PUMM', logoSrc: '/images/clients/PUMM_Logo.png' },
  { name: 'Sri Ternak', logoSrc: '/images/clients/Sri Ternak_Logo.png' },
  { name: 'ToastMaster', logoSrc: '/images/clients/ToastMaster_Logo.png' },
];

export const getClientLogos = (_lang = 'en') => clientLogos;

export default clientLogos;
